export default __webpack_public_path__ + "static/media/Parallax-HUD-Omega Widget.d183a9ad.jpg";